"use client"


import {
  BookOpen,
  Users,
  Globe,
  ArrowRight,
  TrendingUp,
  Library,
  Microscope,
  Trophy,
  Target,
  Heart,
  Briefcase,
  ChevronRight,
  Building2,
  Lightbulb,
  BookMarked,
  Award,
  GraduationCap,
  Calendar,
  Rocket,
  Phone,
  Mail,
  ShieldCheck,
  MapPin,
  Star,
  Camera,
  Newspaper,
  FileText,
  Handshake
} from "lucide-react"
import { Helmet } from 'react-helmet-async';

import { Button } from "../components/ui/button"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { loadPublicPosts, loadPublicEvents } from "../store/slices/publicSlice"
import { getCategoryLabel } from "../utils/categoryLabels"
import { getTypeLabel, getStatusLabel } from "../utils/announcementEventUtils"
import { FORMATION_PROGRAMS } from "../utils/formationConstants"
import heroImage1 from "../assets/TopHeroImages/1.jpg"
import heroImage2 from "../assets/TopHeroImages/2.png"
import heroImage3 from "../assets/TopHeroImages/3.jpg"
import homeImage1 from "../assets/HomeImage/IMG_0810.jpg"
import sportImage from "../assets/HomeImage/sportImage.jpg"
import teamRecteur from "../assets/team/recteur.jpg"
import teamViceRecteur from "../assets/team/v-recteur.jpg"
import teamDAF from "../assets/team/DAF.jpg"
import teamBenign from "../assets/team/benign.jpg"
import DrBeatrice from "../assets/team/DrBeatrice.jpg"
import brochurePng from "../assets/Brochure.png"

import logoAUF from "../assets/Partnerlogo/agence-universitaire-de-la-francophonie-logo-png_seeklogo-236447.png"
import logoUB from "../assets/Partnerlogo/universite du burundi.png"
import logoTeramo from "../assets/Partnerlogo/universita-degli-studi-di-teramo.jpg"
import logoMUST from "../assets/Partnerlogo/Mbarara University of Science and Technology.webp"
import logoUN from "../assets/Partnerlogo/Nations unies.png"
import logoKDU from "../assets/Partnerlogo/KYUNGDONG UNIVERSITY.png"
import logoIFDC from "../assets/Partnerlogo/International Fertilizer Development Center (IFDC).webp"
import logoCFCIB from "../assets/Partnerlogo/CFCIB logo.webp"
import logoEU from "../assets/Partnerlogo/eu_flag.jpg"
import logoUS from "../assets/Partnerlogo/Us.jfif"

const agronomieCtx = require.context("../assets/Agronomie", false, /\.(jpg|jpeg|png|webp)$/i)
const informatiqueCtx = require.context("../assets/informatique", false, /\.(jpg|jpeg|png|webp)$/i)
const americanCornerCtx = require.context("../assets/AmericanCorner", false, /\.(jpg|jpeg|png|webp)$/i)
const campusCtx = require.context("../assets/CampusImages", false, /\.(jpg|jpeg|png|webp|JPG|PNG)$/i)
const getImg = (s) => (typeof s === "string" ? s : s?.default ?? s)
const SECTOR_PHOTOS = [
  { title: "Campus", subtitle: "Nos sites", href: "/campus", images: campusCtx.keys().slice(0, 4).map((k) => getImg(campusCtx(k))) },
  { title: "FSAV · Agronomie", subtitle: "Sciences Agronomiques", href: "/faculte/sav", images: agronomieCtx.keys().slice(0, 4).map((k) => getImg(agronomieCtx(k))) },
  { title: "Sciences & Technologies", subtitle: "Informatique & Labs", href: "/faculte/sciences", images: informatiqueCtx.keys().slice(0, 4).map((k) => getImg(informatiqueCtx(k))) },
  { title: "American Corner", subtitle: "Culture & Anglais", href: "/etudiants/american-corner", images: americanCornerCtx.keys().slice(0, 4).map((k) => getImg(americanCornerCtx(k))) },
]

const PARTNER_LOGO_LIST = [
  { src: logoUS, name: "États-Unis" },
  { src: logoEU, name: "Union Européenne" },
  { src: logoAUF, name: "AUF" },
  { src: logoUB, name: "Université du Burundi" },
  { src: logoTeramo, name: "Teramo University" },
  { src: logoMUST, name: "MUST" },
  { src: logoUN, name: "Nations Unies" },
  { src: logoKDU, name: "KyngDong University" },
  { src: logoIFDC, name: "IFDC", url: "https://ifdc.org" },
  { src: logoCFCIB, name: "CFCIB", url: "https://www.cfcib.bi" },
]

function HomeNewsSection({ navigate }) {
  const dispatch = useDispatch()
  const { posts, events, loading } = useSelector((s) => s.public)

  useEffect(() => {
    dispatch(loadPublicPosts({ limit: 6, sort: 'recent' }))
    dispatch(loadPublicEvents({ status: 'ongoing' }))
  }, [dispatch])

  const recentPosts = posts.slice(0, 6)
  const featured = recentPosts[0]
  const sidePosts = recentPosts.slice(1, 3)
  const bottomPosts = recentPosts.slice(3, 6)
  const ongoingEvents = events.slice(0, 3)

  const getImg = (p) => p?.headlineImage?.url || p?.headlineImage || ''

  if (loading && recentPosts.length === 0) {
    return (
      <section id="actualites" className="py-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="animate-pulse space-y-6">
            <div className="h-8 bg-secondary rounded w-1/3" />
            <div className="grid md:grid-cols-12 gap-6">
              <div className="md:col-span-8 h-96 bg-secondary rounded" />
              <div className="md:col-span-4 space-y-6"><div className="h-44 bg-secondary rounded" /><div className="h-44 bg-secondary rounded" /></div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section id="actualites" className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-1 bg-accent rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-accent">Actualités & Événements</span>
            </div>
            <h2 className="heading-2 font-serif mb-2">Dernières nouvelles</h2>
            <p className="text-lg text-muted-foreground">Restez informé de la vie universitaire</p>
          </div>
          <Button
            variant="outline"
            onClick={() => navigate('/actualites')}
            className="hidden md:flex items-center gap-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground bg-transparent font-semibold border border-border"
          >
            Toutes les actualités
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div>

        <div className="grid md:grid-cols-12 gap-6">
          {featured && (
            <article onClick={() => navigate(`/article/${featured._id}`)} className="md:col-span-8 bg-card border-2 border-border overflow-hidden hover:border-accent transition-all group cursor-pointer">
              <div className="relative aspect-[16/9] overflow-hidden">
                {getImg(featured) && <img src={getImg(featured)} alt={featured.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
                <div className="absolute top-6 left-6 px-4 py-2 bg-accent text-accent-foreground text-sm font-bold">
                  À LA UNE
                </div>
              </div>
              <div className="p-8">
                <div className="flex items-center gap-4 text-sm text-muted-foreground mb-4">
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4" />
                    <time>{new Date(featured.publishedAt || featured.createdAt).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</time>
                  </div>
                  <span>&bull;</span>
                  <span>{getCategoryLabel(featured.category)}</span>
                </div>
                <h3 className="text-3xl font-bold text-foreground mb-4 group-hover:text-primary transition-colors leading-tight">{featured.title}</h3>
                <p className="text-muted-foreground mb-6 text-lg leading-relaxed">{featured.excerpt}</p>
                <div className="inline-flex items-center gap-2 text-primary font-semibold hover:gap-3 transition-all group/link text-lg">
                  Lire l'article complet
                  <ArrowRight className="w-5 h-5 group-hover/link:translate-x-1 transition-transform" />
                </div>
              </div>
            </article>
          )}

          <div className="md:col-span-4 space-y-6">
            {sidePosts.map((sp, idx) => {
              const img = getImg(sp)
              return idx === 0 ? (
                <article key={sp._id} onClick={() => navigate(`/article/${sp._id}`)} className="bg-card border-2 border-border p-6 hover:border-accent transition-all group cursor-pointer">
                  {img && (
                    <div className="aspect-video relative border border-border overflow-hidden mb-4 bg-gradient-to-br from-accent/10 to-primary/10">
                      <img src={img} alt={sp.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    </div>
                  )}
                  <div className="flex items-center gap-2 text-xs text-muted-foreground mb-2">
                    <Calendar className="w-3 h-3" />
                    <time>{new Date(sp.publishedAt || sp.createdAt).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}</time>
                  </div>
                  <h3 className="text-lg font-bold text-foreground mb-2 group-hover:text-primary transition-colors line-clamp-2">{sp.title}</h3>
                  <p className="text-sm text-muted-foreground mb-3 leading-relaxed line-clamp-2">{sp.excerpt}</p>
                  <div className="inline-flex items-center gap-1 text-primary font-semibold text-sm hover:gap-2 transition-all">Lire plus <ArrowRight className="w-4 h-4" /></div>
                </article>
              ) : (
                <article key={sp._id} onClick={() => navigate(`/article/${sp._id}`)} className="bg-gradient-to-br from-primary to-primary/90 text-primary-foreground border-2 border-border p-6 hover:border-accent transition-all cursor-pointer group">
                  <div className="flex items-center gap-2 text-xs mb-3 opacity-90">
                    <Calendar className="w-3 h-3" />
                    <time>{new Date(sp.publishedAt || sp.createdAt).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}</time>
                  </div>
                  <h3 className="text-lg font-bold mb-2 group-hover:text-accent transition-colors line-clamp-2">{sp.title}</h3>
                  <p className="text-primary-foreground/90 text-sm mb-3 leading-relaxed line-clamp-2">{sp.excerpt}</p>
                  <div className="inline-flex items-center gap-1 font-semibold text-sm hover:gap-2 transition-all">Lire plus <ArrowRight className="w-4 h-4" /></div>
                </article>
              )
            })}
          </div>

          {bottomPosts.map((bp) => {
            const img = getImg(bp)
            return (
              <article key={bp._id} onClick={() => navigate(`/article/${bp._id}`)} className="md:col-span-4 bg-card border-2 border-border overflow-hidden hover:border-accent transition-all group cursor-pointer">
                {img && (
                  <div className="aspect-video bg-gradient-to-br from-accent to-primary relative overflow-hidden">
                    <img src={img} alt={bp.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-2 text-xs text-muted-foreground mb-3">
                    <Calendar className="w-3 h-3" />
                    <time>{new Date(bp.publishedAt || bp.createdAt).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}</time>
                    <span>&bull;</span>
                    <span>{getCategoryLabel(bp.category)}</span>
                  </div>
                  <h3 className="text-xl font-bold text-foreground mb-3 group-hover:text-primary transition-colors line-clamp-2">{bp.title}</h3>
                  <p className="text-sm text-muted-foreground mb-4 leading-relaxed line-clamp-2">{bp.excerpt}</p>
                  <div className="inline-flex items-center gap-2 text-primary font-semibold text-sm hover:gap-3 transition-all group/link">
                    Lire plus <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
                  </div>
                </div>
              </article>
            )
          })}
        </div>

        {ongoingEvents.length > 0 && (
          <div className="mt-12">
            <h3 className="text-xl font-bold text-foreground mb-6">Evenements en cours</h3>
            <div className="grid md:grid-cols-3 gap-6">
              {ongoingEvents.map((ev) => (
                <div key={ev._id} className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-all">
                  <span className="inline-block px-2 py-0.5 bg-accent/10 text-accent rounded text-xs font-semibold mb-3">{getTypeLabel(ev.type)}</span>
                  <span className="inline-block px-2 py-0.5 bg-primary/10 text-primary rounded text-xs font-medium mb-3 ml-1">{getStatusLabel(ev.effectiveStatus)}</span>
                  <h4 className="text-lg font-bold text-foreground mb-2 line-clamp-2">{ev.title}</h4>
                  <div className="flex items-center gap-2 text-xs text-muted-foreground mb-2">
                    <Calendar className="w-3 h-3" />
                    <span>{new Date(ev.startDate).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })} - {new Date(ev.endDate).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}</span>
                  </div>
                  {ev.place && <p className="text-xs text-muted-foreground"><MapPin className="w-3 h-3 inline mr-1" />{ev.place}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="mt-8 text-center md:hidden">
          <Button onClick={() => navigate('/actualites')}>
            Toutes les actualités <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  )
}

export default function Home() {
  const navigate = useNavigate()
  const [currentSlide, setCurrentSlide] = useState(0)

  const heroImages = [
    {
      url: heroImage1,
      alt: "Campus principal de l'Université de Ngozi",
    },
    {
      url: heroImage2,
      alt: "Bibliothèque moderne de l'université",
    },
    {
      url: heroImage3,
      alt: "Étudiants sur le campus universitaire",
    }
  ]

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length)
    }, 5000) // Change slide every 5 seconds

    return () => clearInterval(timer)
  }, [heroImages.length])

  return (
    <div className="min-h-screen w-full max-w-full min-w-0 bg-background antialiased overflow-x-hidden">
      <Helmet>
        <title>Université de Ngozi - Paix, Savoir, Développement</title>
        <meta name="description" content="Bienvenue à l'Université de Ngozi (UNG). Une institution d'excellence au Burundi dédiée à la formation, la recherche et la promotion de la paix et du développement durable." />
        <meta name="keywords" content="Université de Ngozi, UNG, Burundi, Enseignement Supérieur, Paix, Développement, Ngozi" />
        <link rel="canonical" href="https://ung.bi/" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ung.bi/" />
        <meta property="og:title" content="Université de Ngozi - Excellence et Leadership" />
        <meta property="og:description" content="Rejoignez l'Université de Ngozi pour une formation de qualité." />
        <meta property="og:image" content="https://ung.bi/og-image.jpg" />
      </Helmet>
      {/* Hero Section - Premium Masthead */}
      <section id="accueil" className="relative overflow-hidden min-h-[85vh] lg:min-h-[90vh] flex items-center w-full max-w-full">
        <div className="absolute inset-0 z-0 w-full">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ease-in-out w-full ${index === currentSlide ? "opacity-100" : "opacity-0"
                }`}
            >
              <div className="w-full h-full overflow-hidden">
                <img
                  src={image.url || "/placeholder.svg"}
                  alt={image.alt}
                  className="w-full h-full object-cover max-w-full"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-primary/80 via-primary/60 to-transparent"></div>
              </div>
            </div>
          ))}
        </div>

        <div className="absolute top-10 right-1/4 w-80 h-80 bg-accent/15 border border-border blur-3xl  z-[1]"></div>
        <div
          className="absolute -bottom-10 left-1/3 w-96 h-96 bg-primary/10 border border-border blur-3xl  z-[1]"
          style={{ animationDelay: "3.5s" }}
        ></div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-3 z-20">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`transition-all ${index === currentSlide ? "w-12 h-2 bg-accent" : "w-2 h-2 bg-white/50 hover:bg-white/80"
                }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10 py-20 w-full">
          <div className="max-w-4xl">
            {/* Editorial Metadata */}
            <div className="flex flex-wrap items-center gap-4 mb-6">
              <span className="text-sm md:text-base uppercase tracking-[0.3em] text-accent font-black">Excellence Académique</span>
              <span className="text-accent">—</span>
              <span className="text-sm md:text-base text-white/80 uppercase font-bold tracking-widest">Depuis 1999</span>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl lg:text-7xl mb-8 leading-[1.1] font-serif tracking-tight font-light text-white">
              Bienvenue à l'Université de Ngozi
            </h1>

            {/* Subheading */}
            <div className="border-l-4 border-accent pl-6 mb-10 max-w-2xl">
              <p className="text-lg md:text-xl font-light leading-relaxed text-white/90">
                Forgez votre avenir avec une éducation de qualité. L'UNG vous offre des programmes académiques
                d'excellence dans un environnement propice à votre épanouissement.
              </p>
            </div>

            {/* Stats - Flat Design */}
            <div className="grid grid-cols-3 gap-4 mb-10 max-w-2xl">
              {[
                { number: "3,000+", label: "Étudiants", icon: Users },
                { number: "120+", label: "Professeurs", icon: Award },
                { number: "20+", label: "Programmes", icon: TrendingUp },
              ].map((stat, index) => (
                <div
                  key={index}
                  className="bg-white/10 backdrop-blur-md p-4 border border-white/20 hover:bg-white/15 transition-colors"
                >
                  <stat.icon className="w-5 h-5 text-accent mb-2" />
                  <div className="text-2xl font-black text-white leading-none mb-1">{stat.number}</div>
                  <div className="text-[10px] text-white/70 uppercase font-black tracking-widest">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap items-center gap-4">
              <Button onClick={() => navigate('/admission')} className="bg-accent text-accent-foreground px-8 py-6 text-sm font-black rounded-xl hover:brightness-110 border-b-4 border-black/10">
                Découvrir nos programmes
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
              <Button
                variant="ghost"
                onClick={() => navigate('/campus')}
                className="text-white border-2 border-white/20 hover:bg-white/10 hover:border-white px-8 py-6 text-sm font-black rounded-xl backdrop-blur-sm"
              >
                Visiter le campus
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Showcase - Vision first */}
      <section className="py-24 bg-background relative overflow-hidden w-full max-w-full border-b border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
            {/* Vision */}
            <div className="relative group">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-accent transition-colors duration-500">
                  <Globe className="w-8 h-8 text-accent group-hover:text-accent-foreground transition-colors duration-500" />
                </div>
                <div>
                  <h3 className="text-4xl font-serif font-bold text-foreground">Notre Vision</h3>
                  <div className="w-12 h-1 bg-accent mt-3 group-hover:w-24 transition-all duration-500"></div>
                </div>
              </div>
              <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed font-light italic border-l-4 border-accent/20 pl-6 py-2">
                "  La vision  d’une institution fait référence à un idéal ou un « rêve » que cette institution poursuit et voudrait voir accompli. Ainsi, la vision de l’Université de Ngozi est celle de « former des cadres de moyen et de haut niveau, capables d’appréhender les problèmes des différents milieux où ils seront appelés à œuvrer et de trouver des solutions appropriées en contribuant à la promotion d’un développement durable et à l’éducation morale et humaine de la société ».
              </p>
            </div>

            {/* Mission */}
            <div className="relative group">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-primary transition-colors duration-500">
                  <Target className="w-8 h-8 text-primary group-hover:text-primary-foreground transition-colors duration-500" />
                </div>
                <div>
                  <h3 className="text-4xl font-serif font-bold text-foreground">Notre Mission</h3>
                  <div className="w-12 h-1 bg-primary mt-3 group-hover:w-24 transition-all duration-500"></div>
                </div>
              </div>
              <ul className="grid sm:grid-cols-2 gap-x-12 gap-y-6">
                                    {[
                                        "Contribuer à l’éducation à la paix et à la réconciliation nationale",
                                        "Offrir un avenir plein d’espoir à la jeunesse de notre pays et des pays voisins",
                                        "Offrir une formation de niveau Baccalauréat, Master, voire Doctorat",
                                        "Promouvoir une recherche appliquée et fondamentale pour le développement socio-économique"
                                    ].map((m, i) => (
                                        <li key={i} className="flex items-start gap-4">
                                            <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
                                                <Target className="w-3 h-3 text-primary" />
                                            </div>
                                            <span className="text-sm text-muted-foreground font-medium">{m}</span>
                                        </li>
                                    ))}
                                </ul>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 mt-16">
            <Button onClick={() => navigate('/mission')} variant="outline" className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold bg-transparent">
              Mission & Vision complètes
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button onClick={() => navigate('/valeurs')} variant="outline" className="border-2 border-accent text-accent hover:bg-accent hover:text-accent-foreground font-semibold bg-transparent">
              Découvrir nos valeurs
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </div>
      </section>

      {/* About UNG - Notre Histoire */}
      <section className="py-24 bg-gradient-to-b from-background to-secondary/20 overflow-hidden w-full max-w-full">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
            <div className="space-y-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-1 bg-accent rounded-full" />
                <span className="text-xs font-black uppercase tracking-[0.3em] text-primary">Notre Histoire</span>
              </div>
              <h2 className="heading-2 font-serif">Plus de 25 ans d'excellence académique</h2>
              <div className="space-y-4 text-muted-foreground leading-relaxed">
                <p>
                  Fondée en 1999, l'Université de Ngozi (UNG) s'est imposée comme l'un des piliers de l'enseignement
                  supérieur au Burundi. Avec une vision claire de former des leaders compétents et responsables, l'UNG a
                  diplômé plus de 8,000 étudiants qui contribuent activement au développement du pays.
                </p>
                <p>
                  Notre institution se distingue par son engagement envers l'excellence académique, la recherche
                  innovante et le développement communautaire. Nous offrons un environnement d'apprentissage stimulant
                  où les étudiants peuvent développer leurs compétences théoriques et pratiques.
                </p>
                <p>
                  Reconnue par le Ministère de l'Éducation et membre de plusieurs réseaux universitaires internationaux,
                  l'UNG continue d'élever ses standards pour répondre aux défis du 21ème siècle.
                </p>
              </div>
              <Button onClick={() => navigate('/historique')} className="bg-primary text-primary-foreground hover:bg-primary/90 border border-border px-6 py-5 font-semibold group">
                Découvrir notre histoire
                <ChevronRight className="w-5 h-5 ml-2 transition-transform" />
              </Button>
            </div>

            <div className="relative">
              <div className="aspect-square border-2 border-border overflow-hidden bg-gradient-to-br from-primary to-accent">
                <img
                  src={SECTOR_PHOTOS[0].images[0]}
                  alt="Histoire de l'UNG"
                  className="w-full h-full object-cover opacity-90"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-accent text-accent-foreground p-8 border border-border max-w-xs">
                <div className="text-5xl font-bold mb-2">8,000+</div>
                <p className="font-semibold">Diplômés depuis 1999</p>
              </div>
            </div>
          </div>

          {/* Inline "En images" strip — mixed with presentation */}
          <div className="mt-20 mb-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-1 bg-primary rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.2em] text-muted-foreground">Campus, facultés & espaces</span>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {SECTOR_PHOTOS.map((sector) => (
                <div
                  key={sector.title}
                  role="button"
                  tabIndex={0}
                  onClick={() => navigate(sector.href)}
                  onKeyDown={(e) => e.key === "Enter" && navigate(sector.href)}
                  className="group bg-card border-2 border-border rounded-xl overflow-hidden hover:border-accent hover:shadow-xl transition-all duration-300 cursor-pointer focus:outline-none focus:ring-2 focus:ring-accent/40"
                >
                  <div className="grid grid-cols-2 gap-px bg-border">
                    {sector.images.slice(0, 4).map((src, i) => (
                      <div key={i} className="aspect-[4/3] bg-muted overflow-hidden">
                        <img src={src} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                      </div>
                    ))}
                  </div>
                  <div className="p-3">
                    <h3 className="text-sm font-bold text-foreground group-hover:text-primary transition-colors">{sector.title}</h3>
                    <span className="inline-flex items-center gap-1 text-primary text-xs font-semibold mt-1 group-hover:gap-2 transition-all">
                      Voir <ArrowRight className="w-3 h-3" />
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex justify-center mt-6">
              <Button onClick={() => navigate("/galerie")} variant="outline" size="sm" className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold">
                <Camera className="w-4 h-4 mr-2" />
                Toute la galerie
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
            {/* Large card spanning 2 columns */}
            <div className="md:col-span-2 bg-gradient-to-br from-primary to-primary/80 text-primary-foreground border-2 border-border p-8 hover:border-accent transition-all">
              <Library className="w-12 h-12 mb-4 opacity-90" />
              <h3 className="text-2xl font-bold mb-3">Bibliothèque</h3>
              <p className="text-primary-foreground/90 mb-6 leading-relaxed">
                Plus de 5,000 ouvrages physiques et accès à 20K+ ressources digitales. Espaces de lecture
                et salles de groupe équipées.
              </p>
              <div className="flex items-center gap-4">
                <div>
                  <div className="text-3xl font-bold">5K+</div>
                  <div className="text-sm opacity-90">Livres</div>
                </div>
                <div className="h-12 w-px bg-primary-foreground/30"></div>
                <div>
                  <div className="text-3xl font-bold">20K+</div>
                  <div className="text-sm opacity-90">Ressources digitales</div>
                </div>
              </div>
            </div>

            {/* Tall card */}
            {/* <div className="md:row-span-2 bg-card border-2 border-border p-8 hover:border-accent transition-all group">
              <div className="w-16 h-16 bg-accent/10 border border-border flex items-center justify-center mb-4 group-hover:bg-accent transition-all">
                <Microscope className="w-8 h-8 text-accent group-hover:text-accent-foreground" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-foreground">Laboratoires de Pointe</h3>
              <p className="text-muted-foreground mb-4 leading-relaxed">
                Équipements modernes pour la recherche en sciences, chimie, biologie et physique.
              </p>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 border border-border bg-accent"></div>
                  <span>Laboratoire de Chimie</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 border border-border bg-accent"></div>
                  <span>Laboratoire de Biologie</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 border border-border bg-accent"></div>
                  <span>Laboratoire Informatique</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 border border-border bg-accent"></div>
                  <span>Salle d'Ingénierie</span>
                </li>
              </ul>
            </div> */}

            {/* Regular card */}
            <div className="bg-gradient-to-br from-accent to-accent/80 text-accent-foreground border-2 border-border p-6 hover:border-primary transition-all">
              <Trophy className="w-10 h-10 mb-3 opacity-90" />
              <h3 className="text-lg font-bold mb-2">Distinctions</h3>
              <p className="text-accent-foreground/90 text-sm leading-relaxed">
                Classée parmi les meilleures universités privées du Burundi
              </p>
            </div>

            {/* Wide card spanning 2 columns */}
            <div className="md:col-span-2 bg-card border-2 border-border p-8 hover:border-accent transition-all">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-primary/10 border border-border flex items-center justify-center flex-shrink-0">
                  <Building2 className="w-8 h-8 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-foreground">Campus UNG</h3>
                  <p className="text-muted-foreground leading-relaxed mb-4">
                    Un campus comprenant des espaces innovants comme l'American Corner et l'Ideas Box pour la recherche et la créativité.
                  </p>
                  <div className="flex flex-wrap gap-3">
                    <span className="px-3 py-1 bg-accent/10 text-accent border border-border text-sm font-medium">
                      Résidences
                    </span>
                    <span className="px-3 py-1 bg-primary/10 text-primary border border-border text-sm font-medium">
                      Terrains de Sport
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Regular card - links to full conventions page */}
            <div
              role="button"
              tabIndex={0}
              onClick={() => navigate('/partenariats')}
              onKeyDown={(e) => e.key === 'Enter' && navigate('/partenariats')}
              className="bg-card border-2 border-border p-6 hover:border-accent transition-all group rounded-xl cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/30"
            >
              <Globe className="w-10 h-10 text-primary mb-3 group-hover:rotate-12 transition-transform" />
              <h3 className="text-lg font-bold mb-2 text-foreground">Partenariats</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                15+ conventions avec institutions locales, nationales et internationales
              </p>
              <span className="inline-flex items-center gap-1 text-primary text-sm font-semibold mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                Voir les conventions <ArrowRight className="w-4 h-4" />
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Section */}

      <section className="py-24 bg-gradient-to-b from-background to-secondary/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-1 bg-primary rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-primary">Notre Leadership</span>
            </div>
            <h2 className="heading-2 font-serif mb-4">Équipe de Direction</h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              Des professionnels expérimentés et dévoués qui guident l'excellence académique de l'université
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {/* Team Member 1 - Rector */}
            <div className="group">
              <div className="relative mb-6 border-2 border-border overflow-hidden h-96 transition-all hover:border-accent">
                <img
                  src={teamRecteur}
                  alt="Dr Abbé Apollinaire BANGAYIMBAGA - Recteur"
                        className="w-full h-full object-cover transition-opacity"
                      />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                  <p className="text-background text-sm leading-relaxed">
                    Plus de 25 ans d'expérience en gestion académique et développement universitaire
                  </p>
                </div>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-foreground mb-1">Dr Abbé Apollinaire BANGAYIMBAGA</h3>
                <div className="text-accent font-semibold mb-2">Recteur</div>
                <p className="text-sm text-muted-foreground">PhD</p>
              </div>
            </div>

            {/* Team Member 2 - Vice Rector */}
            <div className="group">
              <div className="relative mb-6 border-2 border-border overflow-hidden h-96 transition-all hover:border-accent">
                <img
                  src={teamViceRecteur}
                  alt="Dr Abbé Lambert RIYAZIMANA - Directeur des Services Académiques"
                  className="w-full h-full object-cover group- transition-opacity"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                  <p className="text-background text-sm leading-relaxed">
                    Spécialiste en pédagogie moderne et innovation académique
                  </p>
                </div>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-foreground mb-1">Dr Abbé Lambert RIYAZIMANA</h3>
                <div className="text-accent font-semibold mb-2">Directeur des Services Académiques</div>
                <p className="text-sm text-muted-foreground">PhD</p>
              </div>
            </div>

             {/* Team Member 5 - */}
            <div className="group">
              <div className="relative mb-6 border-2 border-border overflow-hidden h-96 transition-all hover:border-accent">
                <img
                  src={DrBeatrice}
                  alt="Dr Soeur Béatrice NTAKAMURENGA - Directrice de la Recherche et l’Innovation"
                  className="w-full h-full object-cover group- transition-opacity"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                  <p className="text-background text-sm leading-relaxed">
                  Développement de la Recherche et l’Innovation
                  </p>
                </div>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-foreground mb-1">Dr Soeur Béatrice NTAKAMURENGA</h3>
                <div className="text-accent font-semibold mb-2">Directeur de la Recherche et l’Innovation</div>
                <p className="text-sm text-muted-foreground">PhD</p>
              </div>
            </div>

            {/* Team Member 3  */}
            <div className="group">
              <div className="relative mb-6 border-2 border-border overflow-hidden h-96 transition-all hover:border-accent">
                <img
                  src={teamBenign}
                  alt="Dr Soeur Bénigne NGENDAKUMANA - Directrice de l'Assurance Qualité"
                  className="w-full h-full object-cover group- transition-opacity"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                  <p className="text-background text-sm leading-relaxed">
                    Promotion de la Culture de la Qualité à tous les niveaux
                  </p>
                </div>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-foreground mb-1">Dr Soeur Bénigne NGENDAKUMANA</h3>
                <div className="text-accent font-semibold mb-2">Directeur d'Assurance Qualité</div>
                <p className="text-sm text-muted-foreground">PhD</p>
              </div>
            </div>

            {/* Team Member 4 - */}
            <div className="group">
              <div className="relative mb-6 border-2 border-border overflow-hidden h-96 transition-all hover:border-accent">
                <img
                  src={teamDAF}
                  alt="Jean-Paul Nzigamasabo - Directeur Financier"
                  className="w-full h-full object-cover group- transition-opacity"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                  <p className="text-background text-sm leading-relaxed">
                    Gestion financière stratégique et planification budgétaire
                  </p>
                </div>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-foreground mb-1">Libère Ndayisenga</h3>
                <div className="text-accent font-semibold mb-2">Directeur Administratif et Financier</div>
                <p className="text-sm text-muted-foreground">Msc</p>
              </div>
            </div>

           

          </div>

          <div className="text-center mt-12">
            <Button onClick={() => navigate('/administration/direction')} variant="outline" className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold bg-transparent">
              <Building2 className="w-4 h-4 mr-2" />
              Voir toute l'administration
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </div>
      </section>


      {/* Why Choose UNG - Value Proposition */}
      <section className="py-24 bg-primary text-primary-foreground relative overflow-hidden w-full max-w-full">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.15),transparent_50%)]" />
        </div>

        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-1 bg-accent rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-accent">Nos Atouts</span>
            </div>
            <h2 className="heading-2 font-serif mb-4 text-white">Pourquoi choisir l'UNG ?</h2>
            <p className="text-lg text-primary-foreground/80 max-w-2xl mx-auto font-light">
              Une université qui allie rigueur académique, innovation et engagement communautaire
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {[
              {
                title: "Innovation Pédagogique",
                desc: "Des méthodes d'enseignement modernes centrées sur l'étudiant et l'acquisition de compétences pratiques.",
                icon: Lightbulb
              },
              {
                title: "Insertion Professionnelle",
                desc: "Un réseau étendu de partenaires locaux et internationaux pour faciliter les stages et l'emploi.",
                icon: Rocket
              },
              {
                title: "Valeurs d'Excellence",
                desc: "Une culture de rigueur, d'intégrité et de responsabilité pour former les leaders de demain.",
                icon: ShieldCheck
              }
            ].map((item, i) => (
              <div key={i} className="bg-primary-foreground/10 border-2 border-primary-foreground/15 p-8 hover:border-accent transition-all group">
                <div className="w-14 h-14 bg-primary-foreground/10 border border-primary-foreground/20 flex items-center justify-center mb-6 group-hover:bg-accent group-hover:border-accent transition-all duration-500">
                  <item.icon className="w-7 h-7 text-accent group-hover:text-accent-foreground transition-colors" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">{item.title}</h3>
                <p className="text-primary-foreground/75 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 mt-4">
            <Button onClick={() => navigate('/valeurs')} className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold px-8 py-6 text-base">
              <Heart className="w-5 h-5 mr-2" />
              Découvrir nos valeurs
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button onClick={() => navigate('/admission')} variant="ghost" className="text-white border-2 border-white/20 hover:bg-white/10 hover:border-white px-8 py-6 text-base font-semibold backdrop-blur-sm">
              Nos programmes
            </Button>
          </div>
        </div>
      </section>
      <section className="py-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-1 bg-accent rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-accent">Nos Programmes</span>
            </div>
            <h2 className="heading-2 font-serif mb-4">Excellence Académique</h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              Des formations de qualité reconnues nationalement et internationalement
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {FORMATION_PROGRAMS.map((program, index) => {
              const isPrimaryFeatured = index === 0
              const isAccentFeatured = index === 5
              const isFeatured = isPrimaryFeatured || isAccentFeatured
              const Icon =
                program.type === 'faculty'
                  ? BookOpen
                  : program.type === 'institut'
                    ? Building2
                    : GraduationCap
              return (
                <div
                  key={program.value}
                  className={
                    isPrimaryFeatured
                      ? 'bg-gradient-to-br from-primary to-primary/90 text-primary-foreground border-2 border-border p-8 hover:border-accent transition-all'
                      : isAccentFeatured
                        ? 'bg-gradient-to-br from-accent to-accent/90 text-accent-foreground border-2 border-border p-8 hover:border-primary transition-all'
                        : 'bg-card border-2 border-border p-8 hover:border-accent transition-all group'
                  }
                >
                  <div
                    className={
                      isPrimaryFeatured
                        ? 'inline-block p-3 bg-primary-foreground/20 border border-border mb-4'
                        : isAccentFeatured
                          ? 'inline-block p-3 bg-accent-foreground/20 border border-border mb-4'
                          : 'inline-block p-3 bg-accent/10 border border-border mb-4 group-hover:bg-accent transition-colors'
                    }
                  >
                    <Icon
                      className={
                        isFeatured
                          ? 'w-8 h-8'
                          : 'w-8 h-8 text-accent group-hover:text-accent-foreground transition-colors'
                      }
                    />
                  </div>
                  <h3 className={`text-xl font-bold ${program.shortLabel ? 'mb-1' : 'mb-3'} ${isFeatured ? '' : 'text-foreground'}`}>
                    {program.shortLabel || program.label}
                  </h3>
                  {program.shortLabel && (
                    <p className={`text-sm mb-3 leading-snug ${isPrimaryFeatured ? 'text-primary-foreground/85' : isAccentFeatured ? 'text-accent-foreground/85' : 'text-muted-foreground'}`}>
                      {program.label}
                    </p>
                  )}
                  <p
                    className={
                      isPrimaryFeatured
                        ? 'mb-6 leading-relaxed text-primary-foreground/90'
                        : isAccentFeatured
                          ? 'mb-6 leading-relaxed text-accent-foreground/90'
                          : 'text-muted-foreground mb-6 leading-relaxed'
                    }
                  >
                    {program.description}
                  </p>
                  <ul
                    className={
                      isFeatured
                        ? 'space-y-2 mb-6'
                        : 'space-y-2 mb-6 text-sm text-muted-foreground'
                    }
                  >
                    {program.highlights.map((h) => (
                      <li key={h} className="flex items-center gap-2">
                        <ChevronRight className={isFeatured ? 'w-4 h-4' : 'w-4 h-4 text-primary'} />
                        <span>{h}</span>
                      </li>
                    ))}
                  </ul>
                  <Button
                    variant={isFeatured ? 'default' : 'outline'}
                    onClick={() => navigate(program.href)}
                    className={
                      isPrimaryFeatured
                        ? 'w-full bg-primary-foreground text-primary hover:bg-primary-foreground/90 border border-border font-semibold'
                        : isAccentFeatured
                          ? 'w-full bg-accent-foreground text-accent hover:bg-accent-foreground/90 border border-border font-semibold'
                          : 'w-full border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground border-border font-semibold bg-transparent'
                    }
                  >
                    En savoir plus
                  </Button>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* Recherche & Innovation */}
      <section className="py-24 bg-secondary/30 border-y border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-1 bg-primary rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-primary">Recherche</span>
            </div>
            <h2 className="heading-2 font-serif mb-4">Recherche & Innovation</h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              L'UNG contribue activement à la recherche scientifique et à l'innovation au Burundi et dans la région des Grands Lacs.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-card border-2 border-border p-8 hover:border-primary transition-all group">
              <div className="w-14 h-14 bg-primary/10 border border-border flex items-center justify-center mb-6 group-hover:bg-primary transition-all">
                <Microscope className="w-7 h-7 text-primary group-hover:text-primary-foreground" />
              </div>
              <h3 className="text-2xl font-bold text-foreground mb-3">Centre de Recherche</h3>
              <p className="text-muted-foreground leading-relaxed mb-6">
                Découvrez nos axes de recherche, équipes scientifiques, équipements de pointe et collaborations pour l'innovation et le développement technologique.
              </p>
              <Button onClick={() => navigate('/recherche/centre')} variant="outline" className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold bg-transparent">
                Explorer le centre
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>

            <div className="bg-card border-2 border-border p-8 hover:border-accent transition-all group">
              <div className="w-14 h-14 bg-accent/10 border border-border flex items-center justify-center mb-6 group-hover:bg-accent transition-all">
                <FileText className="w-7 h-7 text-accent group-hover:text-accent-foreground" />
              </div>
              <h3 className="text-2xl font-bold text-foreground mb-3">Publications Scientifiques</h3>
              <p className="text-muted-foreground leading-relaxed mb-6">
                Consultez les rapports, articles et travaux de recherche publiés par nos enseignants-chercheurs et doctorants dans divers domaines.
              </p>
              <Button onClick={() => navigate('/recherche/publications')} variant="outline" className="border-2 border-accent text-accent hover:bg-accent hover:text-accent-foreground font-semibold bg-transparent">
                Voir les publications
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Student Life & Testimonials */}
      <section className="py-24 bg-gradient-to-b from-secondary/20 to-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-1 bg-primary rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-primary">Vie Étudiante</span>
            </div>
            <h2 className="heading-2 font-serif mb-4">Une expérience enrichissante</h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              Au-delà des cours, découvrez une vie universitaire dynamique et épanouissante
            </p>
          </div>

          <div className="grid md:grid-cols-12 gap-6 mb-12">
            {/* Large featured card */}
            <div className="md:col-span-8 bg-card border-2 border-border overflow-hidden hover:border-accent transition-all group">
              <div className="md:flex">
                <div className="md:w-1/2 aspect-square md:aspect-auto relative overflow-hidden">
                  <img
                    src={sportImage}
                    alt="Activités sportives"
                    className="w-full h-full object-cover group- transition-opacity"
                  />
                </div>
                <div className="md:w-1/2 p-8 flex flex-col justify-center">
                  <div className="inline-block px-3 py-1 bg-accent/10 text-accent border border-border text-sm font-semibold mb-4 w-fit">
                    Sports & Loisirs
                  </div>
                  <h3 className="text-3xl font-bold mb-4 text-foreground">Installations Sportives Modernes</h3>
                  <p className="text-muted-foreground mb-6 leading-relaxed">
                    Équipes de basket ball, football, volley ball, beach volley…. performantes. Plus de 15 clubs sportifs pour
                    tous les niveaux. Tournois inter-facultés organisés chaque semestre.
                  </p>
                  <ul className="space-y-3 mb-6">
                    <li className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-primary/10 border border-border flex items-center justify-center flex-shrink-0">
                        <ChevronRight className="w-4 h-4 text-primary" />
                      </div>
                      <span className="text-foreground font-medium">15+ Clubs sportifs actifs</span>
                    </li>
                    <li className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-primary/10 border border-border flex items-center justify-center flex-shrink-0">
                        <ChevronRight className="w-4 h-4 text-primary" />
                      </div>
                      <span className="text-foreground font-medium">Tournois inter-universitaires</span>
                    </li>
                    <li className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-primary/10 border border-border flex items-center justify-center flex-shrink-0">
                        <ChevronRight className="w-4 h-4 text-primary" />
                      </div>
                      <span className="text-foreground font-medium">Encadrement professionnel</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Side cards */}
            <div className="md:col-span-4 space-y-6">
              <div className="bg-gradient-to-br from-accent to-accent/90 text-accent-foreground border-2 border-border p-6 hover:border-primary transition-all">
                <Heart className="w-10 h-10 mb-3" />
                <h3 className="text-xl font-bold mb-2">Clubs & Associations</h3>
                <p className="text-accent-foreground/90 text-sm mb-4">
                  Plus de 25 clubs étudiants dans différents domaines
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-2 py-1 bg-accent-foreground/20 border border-border text-xs">Culture</span>
                  <span className="px-2 py-1 bg-accent-foreground/20 border border-border text-xs">Arts</span>
                  <span className="px-2 py-1 bg-accent-foreground/20 border border-border text-xs">Débats</span>
                  <span className="px-2 py-1 bg-accent-foreground/20 border border-border text-xs">Tech</span>
                </div>
              </div>

              <div className="bg-gradient-to-br from-primary to-primary/90 text-primary-foreground border-2 border-border p-6 hover:border-accent transition-all">
                <Target className="w-10 h-10 mb-3" />
                <h3 className="text-xl font-bold mb-2">Événements</h3>
                <p className="text-primary-foreground/90 text-sm mb-4">
                  Conférences, séminaires et activités culturelles tout au long de l'année
                </p>
                <div className="text-3xl font-bold">50+</div>
                <div className="text-sm opacity-90">Événements par an</div>
              </div>
            </div>
          </div>

        </div>
      </section>

      
      {/* Partners Section */}
      <section className="py-24 bg-background relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_50%_0%,rgba(0,0,0,0.02),transparent)]" />
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center mb-14">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-1 bg-accent rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-accent">Partenaires</span>
            </div>
            <h2 className="heading-2 font-serif mb-3">Ils nous font confiance</h2>
            <p className="text-muted-foreground max-w-xl mx-auto">
              Plus de 30 conventions et memoranda d'entente avec des institutions locales, nationales et internationales.
            </p>
          </div>

          {PARTNER_LOGO_LIST.length > 0 && (
            <div className="flex flex-wrap items-center justify-center gap-10 mb-12">
              {PARTNER_LOGO_LIST.map((logo) => {
                const content = (
                  <>
                    <div className="w-24 h-20 bg-secondary/50 rounded-2xl border border-border flex items-center justify-center p-4 group-hover:border-primary/40 group-hover:shadow-lg group-hover:scale-105 transition-all duration-300">
                      <img src={logo.src} alt={logo.name} className="max-w-full max-h-full object-contain  group-hover:grayscale-0 opacity-70 group-hover:opacity-100 transition-all duration-300" />
                    </div>
                    <span className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-[10px] font-medium text-muted-foreground whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">{logo.name}</span>
                  </>
                )
                return (
                  <div key={logo.name} className="group relative">
                    {logo.url ? (
                      <a href={logo.url} target="_blank" rel="noopener noreferrer" className="block">{content}</a>
                    ) : (
                      content
                    )}
                  </div>
                )
              })}
            </div>
          )}

          <div className="text-center mt-12">
            <Button variant="outline" onClick={() => navigate('/partenariats')} className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold bg-transparent">
              Voir toutes les conventions de partenariat
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </div>
      </section>

      {/* News Section - Dynamic from API */}
      <HomeNewsSection navigate={navigate} />

      {/* Statistics Showcase */}
      <section className="py-24 bg-primary text-primary-foreground relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1),transparent_50%)]"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-1 bg-white/20 rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-white/80">L'UNG en chiffres</span>
            </div>
            <h2 className="heading-2 font-serif mb-4 text-white">Des résultats qui parlent d'eux-mêmes</h2>
            <p className="text-xl text-primary-foreground/90 font-light">L'excellence mesurée par l'impact</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center group">
              <div className="w-20 h-20 bg-primary-foreground/20 border-2 border-border flex items-center justify-center mx-auto mb-6 transition-transform">
                <Users className="w-10 h-10" />
              </div>
              <div className="text-5xl lg:text-6xl font-bold mb-2">3,000+</div>
              <div className="text-lg text-primary-foreground/90 font-medium">Étudiants actifs</div>
            </div>

            <div className="text-center group">
              <div className="w-20 h-20 bg-primary-foreground/20 border-2 border-border flex items-center justify-center mx-auto mb-6 transition-transform">
                <GraduationCap className="w-10 h-10" />
              </div>
              <div className="text-5xl lg:text-6xl font-bold mb-2">8,000+</div>
              <div className="text-lg text-primary-foreground/90 font-medium">Diplômés depuis 1999</div>
            </div>

            <div className="text-center group">
              <div className="w-20 h-20 bg-primary-foreground/20 border-2 border-border flex items-center justify-center mx-auto mb-6 transition-transform">
                <Award className="w-10 h-10" />
              </div>
              <div className="text-5xl lg:text-6xl font-bold mb-2">120+</div>
              <div className="text-lg text-primary-foreground/90 font-medium">Professeurs qualifiés</div>
            </div>

            <div className="text-center group">
              <div className="w-20 h-20 bg-primary-foreground/20 border-2 border-border flex items-center justify-center mx-auto mb-6 transition-transform">
                <Rocket className="w-10 h-10" />
              </div>
              <div className="text-5xl lg:text-6xl font-bold mb-2">98%</div>
              <div className="text-lg text-primary-foreground/90 font-medium">Taux de réussite</div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-16">
            <div className="bg-primary-foreground/10 backdrop-blur-sm border-2 border-border p-6 border border-primary-foreground/20">
              <div className="text-4xl font-bold mb-2">10+</div>
              <p className="text-primary-foreground/90">Universités partenaires internationales</p>
            </div>
            <div className="bg-primary-foreground/10 backdrop-blur-sm border-2 border-border p-6 border border-primary-foreground/20">
              <div className="text-4xl font-bold mb-2">10</div>
              <p className="text-primary-foreground/90">5 Facultés et 5 Instituts supérieurs professionnels</p>
            </div>
            <div className="bg-primary-foreground/10 backdrop-blur-sm border-2 border-border p-6 border border-primary-foreground/20">
              <div className="text-4xl font-bold mb-2">20+</div>
              <p className="text-primary-foreground/90">Projets de recherche actifs</p>
            </div>
          </div>
        </div>
      </section>

      {/* Éducation à la Paix - Featured Banner */}
      <section className="py-20 bg-gradient-to-r from-primary to-primary/90 text-primary-foreground relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_80%_50%,rgba(255,255,255,0.05),transparent)]" />
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-1 bg-accent rounded-full" />
                <span className="text-xs font-black uppercase tracking-[0.3em] text-accent">Engagement</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-white">Éducation à la Paix</h2>
              <p className="text-primary-foreground/90 leading-relaxed text-lg">
                Au cœur de la devise « Paix, Savoir, Développement », l'UNG promeut la paix, la réconciliation nationale et le vivre-ensemble à travers des projets pédagogiques et le dialogue interculturel.
              </p>
            </div>
            <div className="flex md:justify-end">
              <Button onClick={() => navigate('/education-paix')} className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold px-8 py-6 text-base">
                Découvrir notre engagement
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Explorer l'UNG - Creative Bento Navigation */}
      <section className="py-24 bg-gradient-to-b from-background to-secondary/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-1 bg-accent rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-accent">Explorer</span>
            </div>
            <h2 className="heading-2 font-serif mb-4">Tout découvrir sur l'UNG</h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Parcourez l'ensemble de nos sections pour une vue complète de notre université.
            </p>
          </div>

          {/* Row 1 — Two gradient feature blocks */}
          {/* <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div
              role="button" tabIndex={0}
              onClick={() => navigate('/valeurs')}
              onKeyDown={(e) => e.key === 'Enter' && navigate('/valeurs')}
              className="relative bg-gradient-to-br from-accent to-accent/80 text-accent-foreground p-8 md:p-10 cursor-pointer group hover:shadow-2xl transition-all duration-300 overflow-hidden focus:outline-none focus:ring-2 focus:ring-accent/40"
            >
              <div className="absolute -top-8 -right-8 w-40 h-40 bg-white/10 rounded-full blur-2xl group-hover:scale-150 transition-transform duration-700" />
              <Star className="w-10 h-10 mb-4 opacity-90 relative z-10" />
              <h3 className="text-2xl font-bold mb-2 relative z-10">Nos Valeurs</h3>
              <p className="text-accent-foreground/85 leading-relaxed mb-5 relative z-10">
                Paix, multiculturalité, qualité, coopération internationale et esprit d'entreprise au service de la société.
              </p>
              <span className="inline-flex items-center gap-2 font-semibold text-sm group-hover:gap-3 transition-all relative z-10">
                Découvrir <ArrowRight className="w-4 h-4" />
              </span>
            </div>

            <div
              role="button" tabIndex={0}
              onClick={() => navigate('/campus')}
              onKeyDown={(e) => e.key === 'Enter' && navigate('/campus')}
              className="relative bg-gradient-to-br from-primary to-primary/80 text-primary-foreground p-8 md:p-10 cursor-pointer group hover:shadow-2xl transition-all duration-300 overflow-hidden focus:outline-none focus:ring-2 focus:ring-primary/40"
            >
              <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-white/10 rounded-full blur-2xl group-hover:scale-150 transition-transform duration-700" />
              <MapPin className="w-10 h-10 mb-4 opacity-90 relative z-10" />
              <h3 className="text-2xl font-bold mb-2 relative z-10">Nos Campus</h3>
              <p className="text-primary-foreground/85 leading-relaxed mb-5 relative z-10">
                Deux sites modernes à Ngozi et Bujumbura avec infrastructures complètes et cadre d'apprentissage optimal.
              </p>
              <span className="inline-flex items-center gap-2 font-semibold text-sm group-hover:gap-3 transition-all relative z-10">
                Visiter <ArrowRight className="w-4 h-4" />
              </span>
            </div>
          </div> */}

          {/* Row 2 — Vie Étudiante strip */}
          <div className="mb-6 p-6 md:p-8 bg-secondary/40 border-2 border-border">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
                <Users className="w-4 h-4 text-primary-foreground" />
              </div>
              <h3 className="text-sm font-black uppercase tracking-[0.2em] text-primary">Vie Étudiante & Ressources</h3>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              {[
                { title: "Calendrier", desc: "Dates & examens", href: "/etudiants/calendrier", icon: Calendar },
                { title: "American Corner", desc: "Ressources & échanges", href: "/etudiants/american-corner", icon: BookMarked },
                { title: "Ideas Box", desc: "Clubs & innovation", href: "/etudiants/ideax-box", icon: Lightbulb },
                { title: "Blog Étudiant", desc: "Chroniques & actus", href: "/etudiants/blog", icon: Newspaper },
                { title: "Étudiants Internationaux", desc: "Accueil & intégration", href: "/etudiants-internationaux", icon: Globe },
              ].map((item) => (
                <div
                  key={item.href}
                  role="button" tabIndex={0}
                  onClick={() => navigate(item.href)}
                  onKeyDown={(e) => e.key === 'Enter' && navigate(item.href)}
                  className="flex items-center gap-3 p-3 md:p-4 bg-background border border-border hover:border-primary/40 hover:shadow-md cursor-pointer group transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary/30"
                >
                  <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary transition-colors duration-300">
                    <item.icon className="w-4 h-4 text-primary group-hover:text-primary-foreground transition-colors" />
                  </div>
                  <div className="min-w-0">
                    <span className="text-sm font-bold text-foreground block truncate group-hover:text-primary transition-colors">{item.title}</span>
                    <span className="text-[11px] text-muted-foreground hidden md:block">{item.desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Row 3 — Asymmetric: Galerie (wide dark) + Alumni + Admin */}
          {/* <div className="grid md:grid-cols-12 gap-6">
            <div
              role="button" tabIndex={0}
              onClick={() => navigate('/galerie')}
              onKeyDown={(e) => e.key === 'Enter' && navigate('/galerie')}
              className="md:col-span-6 bg-[#0a192f] text-white p-8 md:p-10 cursor-pointer group hover:shadow-2xl transition-all duration-300 relative overflow-hidden focus:outline-none focus:ring-2 focus:ring-accent/40"
            >
              <div className="absolute top-0 right-0 w-48 h-48 bg-accent/8 rounded-full -translate-y-1/3 translate-x-1/3 group-hover:scale-125 transition-transform duration-700" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary/10 rounded-full translate-y-1/2 -translate-x-1/3" />
              <Camera className="w-10 h-10 mb-4 text-accent relative z-10" />
              <h3 className="text-2xl font-bold mb-2 relative z-10">Galerie Photos</h3>
              <p className="text-white/65 leading-relaxed mb-5 relative z-10">
                Découvrez l'UNG en images : campus, événements marquants, vie étudiante et équipe dirigeante.
              </p>
              <span className="inline-flex items-center gap-2 text-accent font-semibold text-sm group-hover:gap-3 transition-all relative z-10">
                Voir la galerie <ArrowRight className="w-4 h-4" />
              </span>
            </div>

            <div
              role="button" tabIndex={0}
              onClick={() => navigate('/alumni/events')}
              onKeyDown={(e) => e.key === 'Enter' && navigate('/alumni/events')}
              className="md:col-span-3 bg-gradient-to-b from-card to-secondary/30 border-2 border-border p-6 md:p-8 cursor-pointer group hover:border-accent hover:shadow-lg transition-all duration-300 flex flex-col focus:outline-none focus:ring-2 focus:ring-accent/30"
            >
              <Handshake className="w-9 h-9 text-accent mb-4 group-hover:rotate-6 transition-transform duration-300" />
              <h3 className="text-lg font-bold text-foreground mb-1">Alumni & Événements</h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-auto">Réseau des anciens diplômés et communauté de l'UNG.</p>
              <span className="inline-flex items-center gap-1 text-primary text-sm font-semibold mt-4 group-hover:gap-2 transition-all">
                Explorer <ArrowRight className="w-3 h-3" />
              </span>
            </div>

            <div className="md:col-span-3 bg-card border-2 border-border p-6 md:p-8 flex flex-col">
              <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <Building2 className="w-5 h-5 text-primary" />
              </div>
              <h3 className="text-lg font-bold text-foreground mb-4">Administration</h3>
              <nav className="space-y-2 mt-auto">
                {[
                  { title: "Administration Générale", href: "/administration/general" },
                  { title: "Ressources Humaines", href: "/administration/hr" },
                  { title: "Finance", href: "/administration/finance" },
                ].map((link) => (
                  <button
                    key={link.href}
                    onClick={() => navigate(link.href)}
                    className="w-full flex items-center justify-between py-2.5 px-3 text-sm text-muted-foreground hover:text-primary hover:bg-primary/5 border border-transparent hover:border-primary/20 transition-all group/link text-left"
                  >
                    <span className="font-medium">{link.title}</span>
                    <ChevronRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover/link:opacity-100 group-hover/link:translate-x-0 transition-all" />
                  </button>
                ))}
              </nav>
            </div>
          </div> */}
        </div>
      </section>

      {/* Map Section */}
      <section className="py-24 bg-secondary/10 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="w-12 h-1 bg-primary rounded-full" />
              <span className="text-xs font-black uppercase tracking-[0.3em] text-primary">Présence Nationale</span>
            </div>
            <h2 className="heading-2 font-serif mb-4">Nos Campus & Localisation</h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Retrouvez-nous sur nos deux sites principaux à travers le Burundi.</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Ngozi Campus Map */}
            <div className="bg-card border-2 border-border p-4 hover:border-accent transition-all group">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-primary/10 flex items-center justify-center text-primary border border-border">
                  <MapPin className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-foreground leading-none mb-2">Campus Ngozi (Siège)</h3>
                  <p className="text-sm text-muted-foreground uppercase font-black tracking-widest opacity-60">Quartier Kanyami</p>
                </div>
              </div>
              <div className="aspect-[16/9] bg-slate-100 border border-border overflow-hidden relative grayscale hover:grayscale-0 transition-all duration-700">
                <iframe
                  title="Map Ngozi"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.693288922156!2d29.828565973124572!3d-2.9043960395317896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19c395d2489f783b%3A0x1fb404624ebce488!2sUniversity%20of%20Ngozi!5e0!3m2!1sen!2sbi!4v1770724847882!5m2!1sen!2sbi"
                  className="absolute inset-0 w-full h-full border-0"
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
              <div className="mt-6 flex items-center justify-between">
                <div className="flex flex-col gap-1">
                  <span className="text-xs font-black uppercase text-muted-foreground/60">Contact direct</span>
                  <span className="text-sm font-bold text-foreground">+257 22 30 22 59</span>
                </div>
                <Button
                  variant="outline"
                  onClick={() => window.open('https://www.google.com/maps?q=University+of+Ngozi+Ngozi+Burundi', '_blank', 'noopener,noreferrer')}
                  className="text-xs font-black uppercase tracking-widest px-6 border-primary text-primary hover:bg-primary hover:text-white transition-all"
                >
                  Y Aller
                </Button>
              </div>
            </div>

            {/* Bujumbura Campus Map */}
            <div className="bg-card border-2 border-border p-4 hover:border-accent transition-all group">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-accent/10 flex items-center justify-center text-accent border border-border">
                  <MapPin className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-foreground leading-none mb-2">Campus Bujumbura</h3>
                  <p className="text-sm text-muted-foreground uppercase font-black tracking-widest opacity-60">Kamenge, Av. de l'Université</p>
                </div>
              </div>
              <div className="aspect-[16/9] bg-slate-100 border border-border overflow-hidden relative grayscale hover:grayscale-0 transition-all duration-700">
                <iframe
                  title="Map Bujumbura"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7561!2d29.378!3d-3.344!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19c18304996458bf%3A0xb30677498c4d3ec1!2sKamenge%2C%20Bujumbura!5e0!3m2!1sfr!2sbi!4v1700000000000!5m2!1sfr!2sbi"
                  className="absolute inset-0 w-full h-full border-0"
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
              <div className="mt-6 flex items-center justify-between">
                <div className="flex flex-col gap-1">
                  <span className="text-xs font-black uppercase text-muted-foreground/60">Contact direct</span>
                  <span className="text-sm font-bold text-foreground">+257 22 30 22 59</span>
                </div>
                <Button
                  variant="outline"
                  onClick={() => window.open('https://www.google.com/maps?q=Kamenge+Bujumbura+Burundi', '_blank', 'noopener,noreferrer')}
                  className="text-xs font-black uppercase tracking-widest px-6 border-accent text-accent hover:bg-accent hover:text-white transition-all"
                >
                  Y Aller
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-background">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-1 bg-accent rounded-full" />
            <span className="text-xs font-black uppercase tracking-[0.3em] text-accent">Inscriptions Ouvertes</span>
          </div>
          <h2 className="heading-2 font-serif mb-6 text-balance">Prêt à rejoindre l'UNG ?</h2>
          <p className="text-lg md:text-xl text-muted-foreground mb-10 text-balance leading-relaxed max-w-2xl mx-auto font-light">
            Les admissions pour l'année académique 2025-2026 sont ouvertes. Commencez votre voyage vers l'excellence
            académique dès aujourd'hui.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Button onClick={() => navigate('/admission')} className="bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-2xl border border-border px-8 py-6 text-base font-semibold transition-opacity group">
              Commencer votre inscription
              <ArrowRight className="w-5 h-5 ml-2 transition-transform" />
            </Button>
            <a
              href={brochurePng}
              download="Catalogue-Universite-Ngozi.png"
              className="inline-flex items-center justify-center gap-2 border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground border-border px-8 py-6 text-base font-semibold bg-transparent transition-opacity rounded-md"
            >
              <FileText className="w-5 h-5" />
              Télécharger la brochure
            </a>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mt-16">

            <div className="flex items-center gap-4 p-4">
              <div className="w-12 h-12 bg-primary/10 border border-border flex items-center justify-center flex-shrink-0">
                <Phone className="w-6 h-6 text-primary" />
              </div>
              <div className="text-left">
                <div className="font-bold text-foreground">Contact</div>
                <div className="text-sm text-muted-foreground">+257 22 30 22 59</div>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4">
              <div className="w-12 h-12 bg-accent/10 border border-border flex items-center justify-center flex-shrink-0">
                <Mail className="w-6 h-6 text-accent" />
              </div>
              <div className="text-left">
                <div className="font-bold text-foreground">Email</div>
                <div className="text-sm text-muted-foreground">uningozi@univ-ngozi.bi</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
